import { apiUrl } from '../../../settings'

export const chatRoomsUrl = () => {
  return apiUrl + '/api/chatRooms'
}
export const previousChatUrl = () => {
  return apiUrl + `/api/previousChat`
}
